var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPlusDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.992188 7.35938C0.992188 8.01562 1.52344 8.54688 2.17969 8.54688H6.51562V12.8828C6.51562 13.5312 7.03906 14.0703 7.69531 14.0703C8.35156 14.0703 8.88281 13.5312 8.88281 12.8828V8.54688H13.2188C13.8672 8.54688 14.3984 8.01562 14.3984 7.35938C14.3984 6.71094 13.8672 6.17969 13.2188 6.17969H8.88281V1.84375C8.88281 1.19531 8.35156 0.65625 7.69531 0.65625C7.03906 0.65625 6.51562 1.19531 6.51562 1.84375V6.17969H2.17969C1.52344 6.17969 0.992188 6.71094 0.992188 7.35938Z",
    fill: "#68899A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlusDisabled);
export default __webpack_public_path__ + "static/media/ico-plus-disabled.9a53b1d798fdfe737b4e383478b9b29e.svg";
export { ForwardRef as ReactComponent };